export default __webpack_public_path__ + "static/media/356.6c1b4bcc.png";